import { createSlice } from "@reduxjs/toolkit";

export const commonServiceSlice = ({ name, thunk }) => {
  if (!name || !thunk) {
    throw new Error(
      "commonServiceSlice requires both 'name' and 'thunk' parameters",
    );
  }

  return createSlice({
    name,
    initialState: {
      byKey: {},
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(thunk.pending, (state, action) => {
          const key = action.meta.arg;

          state.byKey[key] ??= {
            list: [],
            loading: false,
            error: null,
            hasFetched: false,
          };

          state.byKey[key].loading = true;
          state.byKey[key].error = null;
        })

        .addCase(thunk.fulfilled, (state, action) => {
          const key = action.meta.arg;

          state.byKey[key] = {
            list: action.payload,
            loading: false,
            error: null,
            hasFetched: true,
          };
        })

        .addCase(thunk.rejected, (state, action) => {
          if (action.payload === "__CACHED__") return;

          const key = action.meta.arg;

          state.byKey[key] ??= {
            list: [],
            loading: false,
            error: null,
            hasFetched: false,
          };

          state.byKey[key].loading = false;
          state.byKey[key].error = action.payload || action.error?.message;
          state.byKey[key].hasFetched = true;
        });
    },
  });
};
